import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Skeleton } from 'fpay-ui';

const Card = styled.div`
  background: #ffffff;
  width: 100%;
  height: 74px;
  margin-bottom: 8px;
  padding: 13px 16px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

const RowCard = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TransactionCardSkeleton = ({ index }) => (
  <>
    <Card data-testid={`transaction-card-skeleton-${index}`}>
      <RowCard>
        <Skeleton width="41px" height="20px" type="" />
        <Skeleton width="76px" height="20px" type="" />
      </RowCard>
      <RowCard>
        <Skeleton width="71px" height="20px" type="" />
        <Skeleton width="118px" height="20px" type="" />
      </RowCard>
    </Card>
  </>
);

export default TransactionCardSkeleton;

TransactionCardSkeleton.propTypes = {
  index: PropTypes.string,
};

TransactionCardSkeleton.defaultProps = {
  index: '',
};
